import { ReactComponent as MessageIcon } from "./svg/message.svg";
import "./IconActionMessage.scss";

export const IconActionMessage = () => {
  return (
    <span className="icon-action-message" aria-hidden="true">
      <MessageIcon />
    </span>
  );
};
